import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchPrograms = (setPrograms: Function, setProgramsLoading: Function, language: string) => {
  setProgramsLoading(true);

  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((error) => {
      console.error("Error fetching programs:", error);
      alert(translate(language, "PAGES.EVALUATION.UPDATE_MODAL.ERRORS.PROGRAMS"));
    })
    .finally(() => setProgramsLoading(false));
};

export const updateEvaluation = (
  evaluationId: number,
  payload: any,
  setLoading: Function,
  onSuccess: Function,
  language: string
) => {
  setLoading(true);

  ApiService.put(`evaluations/${evaluationId}`, payload)
    .then((response) => onSuccess(response.data.evaluation))
    .catch((error) => {
      console.error("Error updating evaluation:", error);
      alert(translate(language, "PAGES.EVALUATION.UPDATE_MODAL.ERRORS.UPDATE"));
    })
    .finally(() => setLoading(false));
};
